// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__fmCcf","wrapper":"Title_wrapper__DIf2F"};